import React from "react";
import SeoData from "../jsonData/seo.json";
import * as Wis from "../style/webbutv-details-style";
import { BokaMote } from "../style/bokaMote";
import LM from "../../assets/portraits/LM_portrait.jpg";

interface SeoContent {
  id: string;
  SeoInfoHeader: string;
  text1: string;
  text2: string | string[];
  text3?: string;
}

const typedSeoData: SeoContent[] = SeoData;

export const SeoInfo: React.FC = () => {
  return (
    <Wis.BuildWebbContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "90%",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <Wis.BackArrow />
      </div>
      <Wis.BuildWebbIntroHead>Webbutveckling – SEO</Wis.BuildWebbIntroHead>
      <Wis.BuildWebHeader>SEO</Wis.BuildWebHeader>
      <Wis.Underline />

      <Wis.TwoContainer>
        {typedSeoData.slice(0, 2).map((content) => (
          <Wis.Section key={content.id}>
            <Wis.BuildWebHeading>{content.SeoInfoHeader}</Wis.BuildWebHeading>
            <Wis.BuildWebParagraph>{content.text1}</Wis.BuildWebParagraph>
            <Wis.BuildWebParagraph>{content.text2}</Wis.BuildWebParagraph>
          </Wis.Section>
        ))}
      </Wis.TwoContainer>

      <Wis.FullWidthContainer>
        <Wis.Section>
          <Wis.BuildWebHeading>
            {typedSeoData[2].SeoInfoHeader}
          </Wis.BuildWebHeading>
          <Wis.BuildWebParagraph>{typedSeoData[2].text1}</Wis.BuildWebParagraph>

          {Array.isArray(typedSeoData[2].text2) ? (
            <Wis.StyledList>
              {typedSeoData[2].text2.map((item, index) => {
                const [boldPart, ...rest] = item.split("–");
                return (
                  <Wis.StyledListItem key={index}>
                    <strong>{boldPart.trim()} –</strong> {rest.join("–").trim()}
                  </Wis.StyledListItem>
                );
              })}
            </Wis.StyledList>
          ) : (
            <Wis.BuildWebParagraph>
              {typedSeoData[2].text2}
            </Wis.BuildWebParagraph>
          )}
          <Wis.BuildWebParagraph>{typedSeoData[2].text3}</Wis.BuildWebParagraph>
        </Wis.Section>
      </Wis.FullWidthContainer>

      <BokaMote 
          name="Lena" 
          img={LM} 
          text="Boka ett möte med {name}." 
          email="hello@antech.se"
          subject="Bokningsförfrågan: Möte med Lena"
          body="Hej Lena, Jag är intresserad av att veta mer om webbutveckling & SEO-optimering och skulle gärna boka ett möte med dig."
      />
    </Wis.BuildWebbContainer>
  );
};
